document.addEventListener('change', event => {
  const select = event.target.closest('[data-elirena-sticky-option]');
  if (!select) return;
  const picker = document.querySelector('.elirena-pdp variant-picker');
  const input = picker?.querySelector(`input[data-option-value-id="${CSS.escape(select.value)}"]`);
  if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
});
const seen = new WeakSet();
const storageKey = 'elirena:recent-products';
async function initializeRecentProducts() {
  document.querySelectorAll('[data-elirena-recent]').forEach(async root => {
    if (seen.has(root)) return;
    seen.add(root);
    let previous = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) previous = stored.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle));
      localStorage.setItem(storageKey, JSON.stringify([root.dataset.productHandle, ...previous.filter(handle => handle !== root.dataset.productHandle)].slice(0, 20)));
    } catch { return; }
    const rail = root.querySelector('.elirena-recent-rail');
    const handles = [...new Set(previous)].filter(handle => handle !== root.dataset.productHandle).slice(0, Number(root.dataset.limit) || 9);
    const cards = await Promise.all(handles.map(async handle => {
      try {
        const url = new URL(`${root.dataset.root}products/${encodeURIComponent(handle)}`, location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return null;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        return document.querySelector('template[data-elirena-recent-card]')?.content.cloneNode(true);
      } catch { return null; }
    }));
    cards.forEach(card => {
      if (!card?.childElementCount) return;
      const item = document.createElement('div');
      item.className = 'elirena-recent-item';
      item.append(card);
      rail.append(item);
    });
    root.hidden = rail.childElementCount === 0;
  });
}
document.addEventListener('shopify:section:load', initializeRecentProducts);
initializeRecentProducts();
const currentProduct = document.querySelector('[data-elirena-product-handle]')?.dataset.elirenaProductHandle;
if (currentProduct) {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const handles = Array.isArray(saved) ? saved.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)) : [];
    localStorage.setItem(storageKey, JSON.stringify([currentProduct, ...handles.filter(handle => handle !== currentProduct)].slice(0, 20)));
  } catch {}
}
